/**
 * Debouncer
 * @param {Function} fn Callback de executat
 * @param {Function|Number} delay Delay in milisecunde. Default 300
 * @returns {void}
 */
export const debounce = (fn, delay = 300) => {
	let timeout;
	return (...args) => {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn(...args), typeof delay === 'function' ? delay() : delay);
	};
};
export function waitForRecaptcha({ timeout = 10000, interval = 100 } = {}) {
	return new Promise((resolve, reject) => {
		const startedAt = Date.now();

		const check = () => {
			if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
				resolve(window.grecaptcha);
				return;
			}

			if (Date.now() - startedAt >= timeout) {
				reject(new Error('reCAPTCHA nu e disponibil.'));
				return;
			}

			window.setTimeout(check, interval);
		};

		check();
	});
}

export function showRecaptchaError(selector, message = 'Nu am putut încărca validarea reCAPTCHA. Te rugăm să reîncarci pagina.') {
	document.querySelectorAll(selector).forEach((form) => {
		const errorContainer = form.querySelector('.error-response-container');
		const errorMsg = errorContainer?.querySelector('.nj-inline-message__body');
		const submitBtn = form.querySelector('button[type="submit"]');

		if (errorContainer && errorMsg) {
			errorMsg.textContent = message;
			errorContainer.hidden = false;
		}

		submitBtn && (submitBtn.disabled = true);
	});
}
